import type { TypedDocumentNode, UseQueryResponse } from '@urql/vue';
import QueryResponse from '~/graphql/wrappers/query-response';
import { ApiCall } from '~/graphql/wrappers/api-call';

export default class QueryCall<T = Query, V = any> extends ApiCall<T, V> {
  private query: UseQueryResponse<T, V>;

  constructor(queryDocument: TypedDocumentNode<T, V>, variables?: V) {
    super();
    this.query = this.createQuery({
      query: queryDocument,
      variables,
      requestPolicy: 'network-only',
      pause: true,
    });
  }

  public async run(input?: V): Promise<QueryResponse<T, V>> {
    const result = await this.query.executeQuery(input);
    return new QueryResponse<T, V>(result);
  }
}
